import React, { createContext, useReducer } from "react";
import get_distinct, {
  BRAND,
  CARDNAME,
  CARDNUMBER,
  CARDNUMBER_FIRST_TYPES,
  CardKeys,
  CardKeys_Alt,
  SERIALNUMBER,
  SETNAME,
  SUBSET,
  SubsetKeys,
  YEAR,
  getSerialNumber,
} from "../library/components/SelectCardFromDB/ProcessSets";

function SetObj() {
  this.year = null;
  this.brand = null;
  this.set_name = null;
  this.subset = null;
}

function CardObj() {
  this.card_name = null;
  this.card_number = null;
  this.serial_number = null;
}
// const FULL_LIMIT = 100;
// const RAW_LIMIT = 200;

// const EXPO_DATES = ["Apr 20", "Apr 21", "Apr 22", "Apr 23"];
const urlServiceTypeParam = new URLSearchParams(window.location.search).get(
  "serviceType"
);
let defaultServiceType =
  window.localStorage.getItem("expo_mnt_service_type_val") || "auth-only";
// let defaultServiceDay =
//   window.localStorage.getItem("expo_mnt_service_day_val") || "Apr 20";
// let defaultCardsLimit =
//   defaultServiceType === "same-day-full" ? FULL_LIMIT : RAW_LIMIT;

if (urlServiceTypeParam && !isNaN(parseInt(urlServiceTypeParam))) {
  switch (parseInt(urlServiceTypeParam)) {
    case 1:
      defaultServiceType = "auth-only";
      // defaultCardsLimit = FULL_LIMIT;
      break;
    case 2:
      defaultServiceType = "auth-grading";
      // defaultCardsLimit = RAW_LIMIT;
      break;
    default:
      break;
  }
}

//   window.localStorage.setItem("expo_mnt_service_type_val", defaultServiceType);
// }

const InitialWizard = {
  showCardWizard: false,
  cardWizardStep: 1,
  wizardLoading: false,
  selectedType: null,
  selectedSet: new SetObj(),
  selectedCard: new CardObj(),
  wizardCards: [],
  wizardSets: [],
  d_years: [],
  d_brands: [],
  d_setnames: [],
  d_subsets: [],
  d_cardnames: [],
  d_cardnumbers: [],
  display_serial: "",
};

const initialState = {
  loading: false,
  serviceType: defaultServiceType,
  // serviceDay: defaultServiceDay,
  wizardTypes: window.cardtypes,
  ...InitialWizard,
  // cardsLimit: defaultCardsLimit,
  // EXPO_DATES,
};

const store = createContext(initialState);
const { Provider } = store;

const StateProvider = ({ children }) => {
  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case "setLoadingTrue":
        return {
          ...state,
          loading: true,
        };
      case "setLoadingFalse":
        return {
          ...state,
          loading: false,
        };
      case "updateServiceType": {
        window.localStorage.setItem("expo_mnt_service_type_val", action.value);
        //make sure cards are in limit
        // let cardsLimit = action.value === 'same-day-full' ? FULL_LIMIT : RAW_LIMIT;
        // let cards = JSON.parse(window.localStorage.getItem('expo_mnt_saved_cards'));
        // if(cards && cards.length > 0) {
        //   cards = cards.slice(0, cardsLimit)
        //   window.localStorage.setItem('expo_mnt_saved_cards', JSON.stringify(cards));
        // }
        return {
          ...state,
          serviceType: action.value,
          // cardsLimit: cardsLimit,
        };
      }
      // case "updateServiceDay": {
      //   window.localStorage.setItem("expo_mnt_service_day_val", action.value);
      //   return {
      //     ...state,
      //     serviceDay: action.value,
      //     cardsLimit: action.limit,
      //   };
      // }
      case "toggleCardWizard": {
        // console.log("toggleCardWizard");
        return {
          ...state,
          ...InitialWizard,
          showCardWizard: !state.showCardWizard,
        };
      }
      case "previousStep": {
        return {
          ...state,
          cardWizardStep: state.cardWizardStep - 1,
        };
      }
      case "nextStep": {
        let step = state.cardWizardStep + 1;
        let loading = state.wizardLoading;
        let showWizard = state.showCardWizard;
        let type = state.selectedType;

        switch (step) {
          case 2:
            //fetch sets in selected type || or may be check if its already fetched
            loading = true;
            // show years and brand once loaded
            break;
          case 3:
            loading = true;
            // fetch cards for selected set
            // show cards list ( card name - card number - card set size ) // field to input serial number
            break;
          case 4:
            // add selected set and card deletails in card list and add new card (select selected card id info too to utilize in backend)
            // show cards list ( card name - card number - card set size ) // field to input serial number
            // set case back to 1
            return {
              ...state,
              ...InitialWizard,
            };
          default:
            break;
        }
        return {
          ...state,
          cardWizardStep: step,
          wizardLoading: loading,
          showCardWizard: showWizard,
          selectedType: type,
        };
      }
      case "updateSelectedWizardType": {
        // console.log(action);
        return {
          ...state,
          selectedType: action.value,
        };
      }
      case "updateWizardSets": {
        return {
          ...state,
          wizardSets: action.value,
          d_years: get_distinct(YEAR, action.value),
          d_brands: get_distinct(BRAND, action.value),
          d_setnames: get_distinct(SETNAME, action.value),
          d_subsets: get_distinct(SUBSET, action.value),
          selectedSet: new SetObj(),
          wizardLoading: false,
        };
      }
      case "updateSelectedWizardSet": {
        if (action.payload && action.payload.key && action.payload.value) {
          let updatedSet = state.selectedSet;
          const key = action.payload.key;
          updatedSet[key] = action.payload.value;
          const keyIndex = SubsetKeys.indexOf(key);

          for (let k = 0; k < SubsetKeys.length; k++) {
            if (k > keyIndex) {
              updatedSet[SubsetKeys[k]] = null;
            }
          }
          // console.log(updatedSet);

          const D_years =
            key === YEAR || SubsetKeys.indexOf(YEAR) < keyIndex
              ? state.d_years
              : get_distinct(YEAR, state.wizardSets, updatedSet);

          const D_brands =
            key === BRAND || SubsetKeys.indexOf(BRAND) < keyIndex
              ? state.d_brands
              : get_distinct(BRAND, state.wizardSets, updatedSet);

          const D_setnames =
            key === SETNAME || SubsetKeys.indexOf(SETNAME) < keyIndex
              ? state.d_setnames
              : get_distinct(SETNAME, state.wizardSets, updatedSet);
          //feat: auto select if there is only one set with - value
          if (D_setnames.length === 1 && D_setnames[0] === "-") {
            updatedSet[SETNAME] = "-";
          }

          const D_subsets =
            key === SUBSET || SubsetKeys.indexOf(SUBSET) < keyIndex
              ? state.d_subsets
              : get_distinct(SUBSET, state.wizardSets, updatedSet);
          //feat: auto select if there is only one subset with - value
          if (D_subsets.length === 1 && D_subsets[0] === "-") {
            updatedSet[SUBSET] = "-";
          }

          return {
            ...state,
            d_years: D_years,
            d_brands: D_brands,
            d_setnames: D_setnames,
            d_subsets: D_subsets,
            selectedSet: updatedSet,
          };
        }
        return {
          ...state,
          selectedSet: new SetObj(),
        };
      }
      case "updateWizardCards": {
        return {
          ...state,
          wizardCards: action.value,
          d_cardnames: get_distinct(CARDNAME, action.value),
          d_cardnumbers: get_distinct(CARDNUMBER, action.value),
          selectedCard: new CardObj(),
          display_serial: "",
          wizardLoading: false,
        };
      }
      case "updateSelectedWizardCard": {
        if (action.payload && action.payload.key && action.payload.value) {
          let updatedCard = state.selectedCard;
          const key = action.payload.key;
          updatedCard[key] = action.payload.value;
          let cardKeys =
            CARDNUMBER_FIRST_TYPES.indexOf(state.selectedType) >= 0
              ? CardKeys_Alt
              : CardKeys;
          const keyIndex = cardKeys.indexOf(key);
          if (key !== SERIALNUMBER) {
            for (let k = 0; k < cardKeys.length; k++) {
              if (k > keyIndex) {
                updatedCard[cardKeys[k]] = null;
              }
            }
          }
          //console.log(updatedCard);
          let serial = "";
          if (updatedCard[CARDNUMBER] && updatedCard[CARDNAME]) {
            serial = getSerialNumber(updatedCard, state.wizardCards);
          }
          return {
            ...state,
            d_cardnames:
              key === CARDNAME || cardKeys.indexOf(CARDNAME) < keyIndex
                ? state.d_cardnames
                : get_distinct(CARDNAME, state.wizardCards, updatedCard),
            d_cardnumbers:
              key === CARDNUMBER || cardKeys.indexOf(CARDNUMBER) < keyIndex
                ? state.d_cardnumbers
                : get_distinct(CARDNUMBER, state.wizardCards, updatedCard),
            selectedCard: updatedCard,
            display_serial: serial,
          };
        }
        return {
          ...state,
          selectedCard: new CardObj(),
          display_serial: "",
        };
      }
      // case "updateCardLimit": {
      //   return {
      //     ...state,
      //     cardsLimit: action.value,
      //   };
      // }
      default:
        throw new Error();
    }
  }, initialState);

  return <Provider value={{ state, dispatch }}>{children}</Provider>;
};

export { StateProvider, store };

export const autograpers = window.autographers || ["Other"];
